(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    

const baseURL = "https://gsj.gemist.co/";

window.onload = function() {
  // Get the current URL of the parent page
  const url = window.location.href;
  
  // Get the query string from the URL
  var queryString = url.split('?')[1];
  
  // Create the iframe URL with the query string
  var iframeUrl = baseURL + "designer/gsjrings?" + queryString;
  
  // Set the iframe's source URL
  var iframe = document.getElementById("designer-iframe");
  iframe.src = iframeUrl;
};
  
window.addEventListener("message",
  function(event) {
    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        const designerIframe = document.getElementById("designer-iframe");
        switch (message.type) {
          case 'buy':
            var id = message.product.Shopify.productVariant.split('/').slice(-1)[0];
            var size = message.size;
            var gemstoneData = message.gemstone;
            var rootUrl = new URL(window.location.href);

            let product = {
              'id': id,
              'quantity': 1,
              'properties': {
                'Size': size,
              },
            };

            let cartItems = [product];

            if (gemstoneData && gemstoneData.variantId) {
              cartItems.push({
                'id': gemstoneData.variantId.split('/').slice(-1)[0],
                'quantity': 1,
              });
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  'items': cartItems
                })
              })
              .then(response => {
                addToMiniCartv2();
                setTimeout(function() {
                  addToMiniCartv2();
                }, 4000);

                return response.json().then(data => {
                  if (Array.isArray(data.items)) {
                    const productData = data.items.find(item => item.id == id);
                    if (!productData) {
                      console.error(`Product with ID ${id} not found.`);
                      return data;
                    }

                    let value = 0

                    const cartItems = data.items
                      .map(item => {
                        value += (item.final_line_price / 100);
                        return {
                          ItemPrice: item.final_line_price / 100,
                          ProductName: item.product_title,
                          ProductID: item.variant_id.toString(),
                          ImageURL: item.featured_image.url,
                          ProductURL: rootUrl.origin + item.url,
                          ProductQuantity: item.quantity,
                          Categories: [item.product_type],
                        }
                      });

                    const addedItem = {
                      '$value': value,
                      AddedItemProductName: productData.product_title,
                      AddedItemProductID: productData.id,
                      AddedItemSKU: productData.sku,
                      AddedItemCategories: [].concat.apply([], data.items.map(item => item.product_type)),
                      AddedItemImageURL: productData.featured_image.url,
                      AddedItemURL: rootUrl.origin + productData.url,
                      AddedItemPrice: productData.final_line_price / 100,
                      AddedItemQuantity: 1,
                      AddedItemProductSize: size,
                      items: cartItems,
                    };

                    klaviyo.push(['track', 'Added to Cart', addedItem]);

                    designerIframe.contentWindow.postMessage(
                      { type: 'cart', status: 'added' },
                      '*',
                    );
                  }

                  return data;
                });
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            break;
          case 'updateParams':
            // Get the parameter names from the message
            var paramNames = message.paramNames;
            var currentURL = new URL(window.location.href);
            // Loop through the parameter names
            paramNames.forEach(function(paramName) {
              // Retrieve the corresponding value from the message
              var paramValue = message[paramName];

              // Modify the query parameter of the parent URL with the value
              if (paramValue !== undefined) {
                currentURL.searchParams.set(paramName, paramValue);
              }
            });

            // Replace the parent URL with the modified URL
            window.history.replaceState({}, "", currentURL.toString());
            break;
          case 'download':
            const downloadHref = message.downloadHref;
            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
            break;
          case 'copywindowlocation':
            // Get the current window location
            var windowLocation = window.location.href;

            // Use the Clipboard API to copy the window location to the clipboard
            navigator.clipboard.writeText(windowLocation)
              .then(function() {
                console.log("Window location copied to clipboard successfully");
              })
              .catch(function(error) {
                console.error("Failed to copy window location to clipboard:", error);
              });
            break;
          case 'sendemail':
            let {
              emailContent, subject, recipient
            } = message;
            const currentPageLink = window.location.href;
            emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);

            const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                          subject
                        )}&body=${encodeURIComponent(emailContent)}`;

            if (mailtoLink) {
              window.open(mailtoLink, "_blank");
            }
            break;
          case 'requestParentWindowHref':
            const parentLocationHref = window.location.href;
            designerIframe.contentWindow.postMessage(parentLocationHref, "*");
            break;
          case "requestfullscreen":
            void designerIframe.requestFullscreen();
            break;
          default:
            break;
        }
      } catch (e) {}
    }
  },
  false
);

  } catch(e) { console.error(e); }
})();
})();
